import { apiClient } from './configs/axios-setup'

export type GifStatus = 'pending' | 'processing' | 'completed' | 'failed'

/** A single source frame selected for the animation. */
export interface GifFrameInput {
  /** Full (SAS) URL of the source PNG image. */
  url: string
  caseId?: string
  metricType?: string
  location?: string
  /** Short label shown in the UI (e.g. "80574 · Roof"). */
  label?: string
}

/** User-configurable animation settings. */
export interface GifSettings {
  fps?: number
  delayMs?: number
  loop?: boolean
  name?: string
  /** Optional caption burned into every frame of the GIF. */
  label?: string
}

export interface GifJob {
  jobId: string
  raceTeamId: string
  status: GifStatus
  name: string
  frames: GifFrameInput[]
  settings: { delayMs: number; loop: boolean; name?: string; label?: string }
  frameCount: number
  resultUrl?: string
  sizeBytes?: number
  error?: string
  createByUser: string
  createByUserName: string
  timeCreated: number
  timeUpdated: number
  timeCompleted?: number
}

/** Create an animated GIF generation job. Returns the pending job. */
export const createGif = (frames: GifFrameInput[], settings: GifSettings = {}): Promise<GifJob> => {
  return apiClient.post('/Gifs', { frames, settings }).then(res => res.data.job as GifJob)
}

/** Poll a GIF generation job's status. */
export const getGifJob = (jobId: string): Promise<GifJob> => {
  return apiClient.get(`/Gifs/${encodeURIComponent(jobId)}`).then(res => res.data.job as GifJob)
}

/** List GIF generation jobs for the current team. */
export const listGifs = (limit = 50): Promise<GifJob[]> => {
  return apiClient.get(`/Gifs?limit=${limit}`).then(res => res.data.jobs as GifJob[])
}
